import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';

/** Format JJ/MM/AAAA */
const STOCK_DISPLAY_DATE_FORMAT = 'dd/MM/yyyy';

export const formatStockDateTime = (isoDate: string): string => {
  if (!isoDate || isoDate === '-') {
    return '-';
  }

  try {
    return format(parseISO(isoDate), STOCK_DISPLAY_DATE_FORMAT, { locale: fr });
  } catch {
    return isoDate;
  }
};

export const formatStockDate = (isoDate: string): string => formatStockDateTime(isoDate);

export const getLatestIsoDate = (isoDates: string[]): string => {
  return isoDates.reduce((latest, current) => {
    return new Date(current).getTime() > new Date(latest).getTime() ? current : latest;
  });
};

export const inventPocStockDates = (
  seed: number,
): { dateEntreeStock: string; dateDerniereMiseAJour: string } => {
  const entree = new Date(2026, 2, 1);

  entree.setDate(entree.getDate() - (seed % 90));

  const maj = new Date(entree);

  maj.setDate(maj.getDate() + (seed % 21));

  return {
    dateEntreeStock: entree.toISOString(),
    dateDerniereMiseAJour: maj.toISOString(),
  };
};

export const addDaysToIsoDate = (isoDate: string, days: number): string => {
  const date = parseISO(isoDate);

  date.setDate(date.getDate() + days);

  return date.toISOString();
};
